// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-05da99d0]{display:none}.az-image[data-v-05da99d0]{background-position:50%;background-size:cover;color:transparent;position:relative;width:100%}.az-image img[data-v-05da99d0]{height:100%;max-width:100%;-o-object-fit:cover;object-fit:cover;-o-object-fit:var(--img-object-fit,cover);object-fit:var(--img-object-fit,cover)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
